module.exports = __webpack_public_path__ + "img/dailyrecord.521588cb.svg";